import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import { Load } from '../../components/Load';
import { Header } from '../../components/Header';
import { Select, Options } from '../../components/Select';
import { Sidebar } from '../../components/Sidebar';
import { Main } from '../../components/Main';
import { CardContent } from '../../components/CardContent';
import { Text } from '../../components/Text';
import { Button, Col, Row, Pagination, Modal } from 'react-bootstrap';
import { Subtitle } from '../../components/SubTitle';
import Search from '../../components/Search';
import { Table, TBody, TCell, TGroup, THeader, TRow, ThCell } from '../../components/Table/Table';
import { FillPen, FillPlus } from '../../components/Icons';
import { Title } from '../../components/Title';
import './style.css';
import AlertMessage from '../../components/Alert';

export function Representantes() {
    const [isLoading, setIsLoading] = useState(false);
    const [representantes, setRepresentantes] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [responsiblePerPage, setResponsiblesPerPage] = useState(20);
    const [responsiblePerPageOptions] = useState([5, 10, 15, 20, 50, 100]);
    const [searchQuery, setSearchQuery] = useState('');
    const [nweCurrentFilteredResponsibles, setCurrentFilteredResponsibles] = useState([]);
    const [nivelAcesso, setNivelAcesso] = useState(0)
    const indexOfLastResponsible = currentPage * responsiblePerPage;
    const indexOfFirstResponsible = indexOfLastResponsible - responsiblePerPage;
    const [show, setShow] = useState(false);
    const [idSelected, setIdSelected] = useState('');
    const [alert, setAlert] = useState({ show: false, message: '', variant: 'success' });

    useEffect(() => {
        api.get('nivel-acesso', {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`
            }
        }).then((response: any) => {
            setNivelAcesso(response.data.nivel)
        })
    }, []);

    const handleClose = () => setShow(false);

    const showModal = (id: any) => {
        setIdSelected(id)
        setShow(true)
    }

    const handleExclude = async () => {
        try {
            await api.delete(`representantes/deletar/${idSelected}`);
            loadResponsibles();
            setAlert({ show: true, message: 'Responsável excluído com sucesso!', variant: 'success' });
        } catch (error) {
            setAlert({ show: true, message: 'Erro ao excluir o responsável', variant: 'danger' });
        }
        handleClose();
    }

    useEffect(() => {
        const indexOfLastFilteredResponsible = currentPage * responsiblePerPage;
        const indexOfFirstFilteredResponsible = indexOfLastFilteredResponsible - responsiblePerPage;
        const newCurrentFilteredResponsibles = representantes.slice(indexOfFirstFilteredResponsible, indexOfLastFilteredResponsible);

        setCurrentFilteredResponsibles(newCurrentFilteredResponsibles);
    }, [currentPage, responsiblePerPage, representantes]);



    const loadResponsibles = async () => {
        try {
            let userId = 0;
            const { data: user } = await api.get('dados-usuario');
            if (user.nome === "Administrador") {
                userId = 1;
            } else {
                userId = user.id;
            }
            const userData = {
                id: userId
            }
            const response = await api.post(`representantes`, userData);
            setRepresentantes(response.data);
        } catch (error) {
            setAlert({ show: true, message: 'Erro ao carregar os responsáveis', variant: 'danger' });
        }
    };

    const handleResponsiblesPerPageChange = (value: any) => {
        setResponsiblesPerPage(Number(value));
        setCurrentPage(1);
    };

    useEffect(() => {
        loadResponsibles();
    }, []);

    const handleSearchChange = (value: string) => {
        setSearchQuery(value);
        setCurrentPage(1);
    };

    const paginationItems = () => {
        let items = [];
        const totalPaginas = Math.ceil(representantes.length / responsiblePerPage);

        // Primeira página
        if (currentPage > 2) {
            items.push(
                <Pagination.Item
                    key="first"
                    onClick={() => setCurrentPage(1)}
                >
                    1
                </Pagination.Item>
            );
        }

        // Reticências antes da página atual, se necessário
        if (currentPage > 3) {
            items.push(<Pagination.Ellipsis key="startEllipsis" disabled />);
        }

        // Página anterior à atual, se aplicável
        if (currentPage > 1) {
            items.push(
                <Pagination.Item
                    key={currentPage - 1}
                    onClick={() => setCurrentPage(currentPage - 1)}
                >
                    {currentPage - 1}
                </Pagination.Item>
            );
        }

        items.push(
            <Pagination.Item
                key={currentPage}
                active
            >
                {currentPage == null || currentPage == undefined || currentPage == 0 ? (
                    0
                ) : (
                    currentPage
                )}
            </Pagination.Item>
        );


        // Página seguinte à atual, se aplicável
        if (currentPage < totalPaginas) {
            items.push(
                <Pagination.Item
                    key={currentPage + 1}
                    onClick={() => setCurrentPage(currentPage + 1)}
                >
                    {currentPage + 1}
                </Pagination.Item>
            );
        }

        // Reticências depois da página atual, se necessário
        if (currentPage < totalPaginas - 2) {
            items.push(<Pagination.Ellipsis key="endEllipsis" disabled />);
        }

        // Última página
        if (currentPage < totalPaginas - 1) {
            items.push(
                <Pagination.Item
                    key="last"
                    onClick={() => setCurrentPage(totalPaginas)}
                >
                    {totalPaginas}
                </Pagination.Item>
            );
        }

        return items;
    };

    return (
        <div>
            <Load isLoading={isLoading} />
            <Sidebar />
            <Header route='./' />
            <Main>
                <Modal show={show} onHide={handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>Confirmação de exclusão</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>Você tem certeza que deseja excluir este item?</Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>
                            Cancelar
                        </Button>
                        <Button variant="primary" onClick={handleExclude}>
                            Confirmar
                        </Button>
                    </Modal.Footer>
                </Modal>

                <CardContent>
                    <Row className='my-4'>
                        <Title text="Representantes Comerciais" />

                        {nivelAcesso !== 2 && (
                            <Col md={8}>
                                <Button className='btn-main' href={`/representantes/cadastrar`}><FillPlus /> Novo Representante</Button>
                            </Col>
                        )}
                        <Col md={4}>
                            <Search placeHolder="Procure pelo nome" onChange={handleSearchChange} />
                        </Col>
                    </Row>
                    <Row className='mb-4'>
                        <Col sm={10} className='my-2 d-flex align-items-end'>
                            {responsiblePerPage ? (
                                <span>Página {currentPage} de {Math.ceil(representantes.length / responsiblePerPage)}</span>
                            ) : (
                                <span>Página {currentPage} de 0</span>
                            )}


                        </Col>
                        <Col sm={2} className='my-2 d-flex justify-content-end'>
                            <Select id='employeesPerPageSelect' onSelect={handleResponsiblesPerPageChange}>
                                {responsiblePerPageOptions.map((option) => (
                                    <Options
                                        key={option}
                                        value={option}
                                        name={`${option} por página`}
                                        selected={option === responsiblePerPage}
                                    />
                                ))}
                            </Select>

                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <div style={{ border: '1px solid #007bff', borderRadius: '6px', overflow: 'hidden', marginTop: '30px' }}>
                                <div style={{ overflow: 'auto' }}>
                                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                        <thead>
                                            <tr style={{ backgroundColor: '#007bff', color: 'white', textAlign: 'center' }}>
                                                <th style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid white', fontSize: '14px', fontWeight: 'normal' }}>Representante</th>
                                                <th style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid white', fontSize: '14px', fontWeight: 'normal' }}>Chave PIX</th>
                                                <th style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid white', fontSize: '14px', fontWeight: 'normal' }}>Número do Documento</th>
                                                <th style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid white', fontSize: '14px', fontWeight: 'normal' }}>URL</th>
                                                <th style={{ padding: '15px', textAlign: 'center', fontSize: '14px', fontWeight: 'normal' }}>Ações</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {representantes.length > 0 ? (
                                                representantes.map((responsible: any) => (
                                                    <tr key={responsible.id} style={{ textAlign: 'center' }}>
                                                        <td style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid lightgray', borderTop: '1px solid lightgray', fontSize: '12px' }}>
                                                            {responsible.nome}
                                                        </td>
                                                        <td style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid lightgray', borderTop: '1px solid lightgray', fontSize: '12px' }}>
                                                            {responsible.chave_pix}
                                                        </td>
                                                        <td style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid lightgray', borderTop: '1px solid lightgray', fontSize: '12px' }}>
                                                            {responsible.documento}
                                                        </td>
                                                        <td style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid lightgray', borderTop: '1px solid lightgray', fontSize: '12px', wordBreak: 'break-word' }}>
                                                            {`${window.location.origin}/new-register?rep=${responsible.uuid}`}
                                                        </td>
                                                        <td style={{ padding: '15px', textAlign: 'center', borderTop: '1px solid lightgray', fontSize: '12px' }}>
                                                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px' }}>
                                                                <Button variant='outline-main' href={`/representantes/editar/${responsible.id}`}>Editar</Button>
                                                                {nivelAcesso !== 2 && (
                                                                    <Button
                                                                        variant='outline-danger'
                                                                        onClick={() => showModal(responsible.id)}
                                                                    >
                                                                        Excluir
                                                                    </Button>
                                                                )}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan={6} style={{ padding: '15px', textAlign: 'center', fontSize: '12px' }}>
                                                        Não há dados para serem mostrados
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </Col>
                        <Col className='d-flex justify-content-center mt-4'>
                            <div className="pagination">
                                <Pagination>
                                    {paginationItems()}
                                </Pagination>
                            </div>
                        </Col>
                    </Row>
                </CardContent>
            </Main>
            <AlertMessage
                show={alert.show}
                message={alert.message}
                variant={alert.variant}
                onClose={() => setAlert({ ...alert, show: false })}
            />
        </div >
    );
}